import { render, staticRenderFns } from "./gdBgtsResult.vue?vue&type=template&id=4bd7b9c6&scoped=true&"
import script from "./gdBgtsResult.vue?vue&type=script&lang=js&"
export * from "./gdBgtsResult.vue?vue&type=script&lang=js&"
import style0 from "./gdBgtsResult.vue?vue&type=style&index=0&id=4bd7b9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7b9c6",
  null
  
)

export default component.exports